import MarkdownContent from "./MarkdownContent";

/** Full-pane markdown viewer with GFM tables, task lists, and LaTeX math. */
export default function MarkdownViewer(props: { markdown: string }) {
  return (
    <div className="h-full overflow-auto px-6 py-4">
      <MarkdownContent markdown={props.markdown} />
    </div>
  );
}
